<template>
<v-container fluid>
    <v-card>
        <v-card-title>
            <h2> Cherry Rate </h2>
            <v-spacer></v-spacer>
            <v-btn @click="createRateDialog=true" color="primary" v-if="ratesCount <= 0 && $can('CAN_CREATE_CHERRY_RATE')"> Update Rate </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              class="elevation-1"
            >
            <template v-slot:item.actions="{ item }">
              <v-btn @click="editItem(item)" color="primary"> Edit </v-btn>
            </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <v-dialog persisent v-model="createRateDialog" width="50rem">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field label="Rate" v-model="cherryRateTemp.rate"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="createRateDialog == false"> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="createRate" color="primary"> Create </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persisent v-model="editDialog" width="50rem">
      <v-card>
        <v-card-title> Edit Rate </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field label="Rate" v-model="cherryRateTemp.rate"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="editDialog == false"> Cancel </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="createRate" color="primary"> Update </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>
<script>
import http from '../../../http'

export default {
  name: 'ManageRates',
  data: function () {
    return {
      rates: [],
      createRateDialog: false,
      cherryRateTemp: { rate: 0 },
      loading: false,
      headers: [
        { text: 'FCS', value: 'organisation.organisationName' },
        { text: 'Rate', value: 'rate' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      editDialog: false,
      rate: {}
    }
  },
  mounted () {
    this.getRates()
  },
  computed: {
    ratesCount: function () {
      return this.rates.length
    }
  },
  methods: {
    editItem (item) {
      this.editDialog = true
      this.cherryRateTemp = item
    },
    createRate () {
      this.loading = true
      http.post('/cherry/rate/update', this.cherryRateTemp).then(response => {
        if (response.data.error) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'warning', message: response.data.message }, { root: true })
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message }, { root: true })
        }
        this.createRateDialog = false
        this.editDialog = false
        this.getRates()
      }).catch(error => {
        this.createRateDialog = false
        this.editDialog = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
      })
    },
    getRates () {
      http.get('/cherry/rate/approved')
        .then(response => {
          this.rates = response.data
        })
        .catch(error => {
          console.log('error', error)
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
        })
    }
  }
}
</script>
<style>
</style>
